
import React from "react";
import UserInfoForm from "./user-info-form";

interface UserInfoModalProps {
  onClose: () => void;
  username: string;
  password: string;
  totp_qr_code: string;
}

const UserInfoModal: React.FC<UserInfoModalProps> = ({
  onClose,
  username,
  password,
  totp_qr_code,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 px-4">
      <div className="w-full max-w-md rounded-3xl bg-white p-8 shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between">
          <h3 className="text-2xl font-semibold text-slate-800">Thông tin đăng nhập</h3>
          <button onClick={onClose} type="button" className="text-slate-400 hover:text-slate-600 text-xl">
            ✕
          </button>
        </div>

        <UserInfoForm
          username={username}
          password={password}
          totp_qr_code={totp_qr_code}
        />

        {/* Footer */}
        <div className="mt-8 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="rounded-full bg-green-600 px-8 py-3 text-sm font-semibold text-white shadow hover:bg-green-700"
          >
            Đã hiểu
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserInfoModal;
